<div class="selector no-text-select" [@fadeInUp]>

    <h2 class="selector__title">Selecciona la aseguradora que deseas consultar</h2>

    <div class="selector__list">
        <a class="selector__item" *ngFor="let entity of entities" (click)="onSelect(entity.key)">
            <span class="selector__logo" [ngStyle]="getStyle(entity.key)"></span>
            <span class="selector__name">{{ entity.value }}</span>
            <img class="selector__chevron" src="/resources/assets/images/ic-chevron-forward.svg" alt="" aria-hidden="true" />
        </a>
    </div>

</div>
